"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _customButton = _interopRequireDefault(require("../buttons/customButton.js"));

var _itemTitle = _interopRequireDefault(require("./itemTitle.js"));

var _itemDescription = _interopRequireDefault(require("./itemDescription.js"));

var _lineHeightFixer = _interopRequireDefault(require("./lineHeightFixer.js"));

var _consts = _interopRequireDefault(require("@wix/photography-client-lib/dist/src/utils/consts"));

var _utils = _interopRequireDefault(require("../../../utils"));

var _designConsts = _interopRequireDefault(require("../../../constants/designConsts.js"));

var _settings = require("@wix/photography-client-lib/dist/src/versioning/features/settings");

var _lodash = _interopRequireDefault(require("lodash"));

var _constants = require("constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var Texts =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Texts, _React$Component);

  function Texts(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.debouncedTryFixLineHeight = _lodash["default"].debounce(_this.tryFixLineHeight, 500);
    return _this;
  }

  var _proto = Texts.prototype;

  _proto.getElementClassNames = function getElementClassNames() {
    var _this$props = this.props,
        showShare = _this$props.showShare,
        styleParams = _this$props.styleParams,
        isNarrow = _this$props.isNarrow;
    var classNames = ['gallery-item-text'];

    if (showShare) {
      classNames.push('hidden');
    }

    if (styleParams.showArrows) {
      classNames.push('padded-horizontal');
    }

    if (isNarrow) {
      classNames.push('narrow-item');
    }

    return classNames.join(' ');
  };

  _proto.allowAnyAction = function allowAnyAction() {
    var styleParams = this.props.styleParams;
    return styleParams.loveButton || styleParams.allowSocial || styleParams.allowDownload;
  };

  _proto.getElementStyle = function getElementStyle() {
    var _this$props2 = this.props,
        styleParams = _this$props2.styleParams,
        style = _this$props2.style;
    var textsDisplayOnHover = !styleParams.isSlideshow && !styleParams.isSlider && !styleParams.hasThumbnails && styleParams.titlePlacement === _consts["default"].placements.SHOW_ON_HOVER;
    var isCentered = style.justifyContent === 'center';
    var elementStyle = {
      justifyContent: styleParams.galleryVerticalAlign,
      alignItems: styleParams.galleryHorizontalAlign,
      textAlign: styleParams.galleryTextAlign
    }; //Set the texts fixed height considering the height of the love and share buttons which is about 100px;

    if (textsDisplayOnHover && this.allowAnyAction() && (styleParams.allowTitle || styleParams.allowDescription)) {
      elementStyle.paddingBottom = 70;
    }

    if (isCentered) {
      elementStyle.marginTop = style.height / 15;
    }

    return elementStyle;
  };

  _proto.getItemTexts = function getItemTexts() {
    var _this2 = this;

    var _this$props3 = this.props,
        title = _this$props3.title,
        description = _this$props3.description,
        id = _this$props3.id,
        styleParams = _this$props3.styleParams,
        style = _this$props3.style,
        isNarrow = _this$props3.isNarrow,
        shouldShowButton = _this$props3.shouldShowButton;
    var shouldShowTitle = title && styleParams.allowTitle;
    var shouldShowDescription = description && styleParams.allowDescription;

    var isNewMobileSettings = _settings.settingsVersionManager.newMobileSettings();

    var titleSpanStyle = {};
    var descSpanStyle = {};
    var titleStyle, descStyle;

    if (shouldShowDescription) {
      titleStyle = {
        marginBottom: _designConsts["default"].spaceBetweenTitleAndDescription
      };
    } else if (shouldShowButton) {
      titleStyle = {
        marginBottom: _designConsts["default"].spaceBetweenElements
      };
    } else {
      titleStyle = {
        marginBottom: 0
      };
    }

    if (shouldShowButton) {
      descStyle = {
        marginBottom: _designConsts["default"].spaceBetweenElements
      };
    } else {
      descStyle = {
        marginBottom: 0
      };
    }

    if (_utils["default"].isMobile() && isNewMobileSettings) {
      // ovveride desktop color and fonts
      if (styleParams.isSlideshowFont) {
        if (typeof styleParams.itemFontSlideshow !== 'undefined') {
          titleStyle.font = styleParams.itemFontSlideshow.value;
          titleStyle.textDecoration = styleParams.textDecorationTitle;
        }

        if (typeof styleParams.itemDescriptionFontSlideshow !== 'undefined') {
          descStyle.font = styleParams.itemDescriptionFontSlideshow.value;
          descStyle.textDecoration = styleParams.textDecorationDesc;
        }

        if (typeof styleParams.itemFontColorSlideshow !== 'undefined') {
          titleStyle.color = styleParams.itemFontColorSlideshow.value;
          titleStyle.textDecorationColor = styleParams.itemFontColorSlideshow.value;
        }

        if (typeof styleParams.itemDescriptionFontColorSlideshow !== 'undefined') {
          descStyle.color = styleParams.itemDescriptionFontColorSlideshow.value;
          descStyle.textDecorationColor = styleParams.itemDescriptionFontColorSlideshow.value;
        }
      } else {
        if (typeof styleParams.itemFont !== 'undefined') {
          titleStyle.font = styleParams.itemFont.value;
          titleStyle.textDecoration = styleParams.textDecorationTitle;
        }

        if (typeof styleParams.itemDescriptionFont !== 'undefined') {
          descStyle.font = styleParams.itemDescriptionFont.value;
          descStyle.textDecoration = styleParams.textDecorationDesc;
        }

        if (typeof styleParams.itemFontColor !== 'undefined') {
          titleStyle.color = styleParams.itemFontColor.value;
          titleStyle.textDecorationColor = styleParams.itemFontColor.value;
        }

        if (typeof styleParams.itemDescriptionFontColor !== 'undefined') {
          descStyle.color = styleParams.itemDescriptionFontColor.value;
          descStyle.textDecorationColor = styleParams.itemDescriptionFontColor.value;
        }
      }
    }

    var titleElem = shouldShowTitle && _react["default"].createElement(_itemTitle["default"], {
      key: 'item-title-' + id,
      title: title,
      style: titleStyle,
      spanStyle: titleSpanStyle
    });

    var descriptionElem = shouldShowDescription && _react["default"].createElement(_itemDescription["default"], {
      key: 'item-description-' + id,
      description: description,
      style: descStyle,
      spanStyle: descSpanStyle
    });

    var buttonElem = shouldShowButton && _react["default"].createElement(_customButton["default"], {
      type: "button",
      styleParams: styleParams,
      style: style,
      small: isNarrow
    });

    var shouldHideElement = !titleElem && !descriptionElem && !buttonElem;

    if (shouldHideElement) {
      return null;
    }

    var elementStyle = this.getElementStyle();
    var classNames = this.getElementClassNames();
    return _react["default"].createElement("div", {
      style: elementStyle,
      ref: function ref(x) {
        return _this2.container = x;
      },
      className: classNames,
      dir: "auto"
    }, titleElem, descriptionElem, buttonElem);
  };

  _proto.tryFixLineHeight = function tryFixLineHeight() {
    try {
      _lineHeightFixer["default"].fix(this.props, this.container);
    } catch (e) {
      if (_utils["default"].isVerbose()) {
        console.error('Error on componentDidUpdate', e);
      }
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (_lineHeightFixer["default"].shouldFix(prevProps, this.props)) {
      this.debouncedTryFixLineHeight();
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    var _this3 = this;

    this.tryFixLineHeight();
    setTimeout(function () {
      _this3.tryFixLineHeight(); //waiting for wix inline styles to take affect

    }, 1000);
  };

  _proto.render = function render() {
    return this.getItemTexts();
  };

  return Texts;
}(_react["default"].Component);

exports["default"] = Texts;